export enum DeviceSubTypeEnum {
    Oil = 1,
    Water = 2
}
